<template>
  <base-dialog @cancel="cancelDialog">
    <div slot="header">{{ $t('scope.join_group_qrcode') }}</div>
    <div slot="body">
      <div style="text-align: center;">
        <img :src="qrcodeUrl" v-if="qrcodeUrl" style="width: 300px; height: 300px;" />
        <div v-else>
          <a-spin :spinning="loading" />
        </div>
      </div>
    </div>
    <div slot="footer">
      <a-button type="primary" @click="cancelDialog" :loading="loading">{{ $t('dialog.ok') }}</a-button>
    </div>
  </base-dialog>
</template>

<script>
import DialogMixin from '@/mixins/dialog'
import WindowsMixin from '@/mixins/windows'

export default {
  name: 'WecomExtGroupsQrcodeDialog',
  mixins: [DialogMixin, WindowsMixin],
  data () {
    return {
      loading: false,
      qrcodeUrl: '',
    }
  },
  created () {
    this.fetchQrcodeUrl()
  },
  methods: {
    async fetchQrcodeUrl () {
      this.loading = true
      try {
        if (this.params.chat_id) {
          const res = await new this.$Manager('wecom_ext_groups').getSpecific({
            id: this.params.chat_id,
            spec: 'qrcode',
          })
          this.qrcodeUrl = res.data.url
        } else if (this.params.service_id) {
          const res = await new this.$Manager('customerservices').performAction({
            id: this.params.service_id,
            action: 'qrcode',
          })
          this.qrcodeUrl = res.data.url
        }
      } catch (error) {
        this.loading = false
      } finally {
        this.loading = false
      }
    },
  },
}
</script>
